// Pure form-state helpers for the order screen. No React, no I/O.

import type { FieldError, OrderForm } from '@hearingaid/shared'

/** A blank form dated `today`; the submission key is minted once and kept across retries. */
export function newForm(today: string, key: string = crypto.randomUUID()): OrderForm {
  return {
    submission_key: key,
    order_date: today,
    participant_name: '',
    member_number: '',
    center_id: null,
    product_id: null,
  }
}

/** Picking a hearing aid selects it (replacing any other); clicking the picked one again clears it. */
export function pickProduct(f: OrderForm, productId: string, on: boolean): OrderForm {
  return { ...f, product_id: on ? productId : null }
}

export function errorFor(errors: FieldError[], field: string): string | null {
  return errors.find((e) => e.field === field)?.message ?? null
}
